module.exports = __webpack_public_path__ + "static/media/007_g6_10My Shows.795253ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/007_g6_10My Shows.png
// module id = 434
// module chunks = 0